export const CONTROL_BAR_LAYOUT_STANDARD = "standard";
export const CONTROL_BAR_LAYOUT_ADAPTIVE = "adaptive";
export const CONTROL_BAR_LAYOUTS = [CONTROL_BAR_LAYOUT_STANDARD, CONTROL_BAR_LAYOUT_ADAPTIVE];
export const ALL_CALL_CONTROLS = null;
export const ADAPTIVE_CONTROL_TIERS = Object.freeze([
  ALL_CALL_CONTROLS,
  Object.freeze(["mic", "camera", "screenshare", "leave"]),
  Object.freeze(["mic", "camera", "leave"]),
]);
export const STANDARD_CONTROL_TIERS = Object.freeze([
  ALL_CALL_CONTROLS,
  Object.freeze(["mic", "camera", "raise-hand", "break", "leave", "roster", "settings", "chat"]),
  Object.freeze(["mic", "camera", "leave", "chat"]),
]);
const TIERS_BY_LAYOUT = Object.freeze({
  [CONTROL_BAR_LAYOUT_STANDARD]: STANDARD_CONTROL_TIERS,
  [CONTROL_BAR_LAYOUT_ADAPTIVE]: ADAPTIVE_CONTROL_TIERS,
});

export const FULLEST_CONTROL_TIER = 0;
export const SPAREST_CONTROL_TIER = ADAPTIVE_CONTROL_TIERS.length - 1;

export function controlTiersFor(layout) {
  const tiers = TIERS_BY_LAYOUT[layout];
  if (!tiers) {
    throw new Error(`control-bar-fit: unknown control bar layout ${JSON.stringify(layout)}; expected one of ${CONTROL_BAR_LAYOUTS.join(", ")}`);
  }
  return tiers;
}

export function isCallControlShown(layout, tier, control) {
  const shown = controlTiersFor(layout)[tier];
  if (shown === undefined) {
    throw new Error(`control-bar-fit: no control tier ${JSON.stringify(tier)}; tiers run ${FULLEST_CONTROL_TIER}..${SPAREST_CONTROL_TIER}`);
  }
  return shown === ALL_CALL_CONTROLS || shown.includes(control);
}

export function nextControlTier({ tier, needed, available, widthNeededByTier }) {
  if (needed > available && tier < SPAREST_CONTROL_TIER) {
    return { tier: tier + 1, widthNeededByTier: { ...widthNeededByTier, [tier]: needed } };
  }
  const roomierTier = tier - 1;
  if (roomierTier >= FULLEST_CONTROL_TIER && available >= widthNeededByTier[roomierTier]) {
    return { tier: roomierTier, widthNeededByTier };
  }
  return { tier, widthNeededByTier };
}

export function widthNeededForControls({ buttonWidths, gap, padding }) {
  if (buttonWidths.length === 0) {
    return 0;
  }
  const buttons = buttonWidths.reduce((sum, width) => sum + width, 0);
  const gaps = gap * (buttonWidths.length - 1);

  return Math.ceil(buttons + gaps + padding);
}
